import * as actions from "../actions/Type";
const intialState = {
  add_todo: {},
  items: [],
  checked: {},
  list_of_rent_property: [],
};
const TodoAppReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.ADD_TODO_APP:
      return {
        ...state,
        add_todo: action.payload,
      };
    case actions.GET_LIST_TODO_APP:
      return {
        ...state,
        items: action.payload,
      };
    case actions.UPDATEING_TODO_APP_CHECKBOX:
      return {
        ...state,
      };

    case actions.DELETE_TODO_APP_CHECKBOX:
      return {
        ...state,
      };
    case actions.DELETE_TODO_AGENT_BRANCH:
      return {
        ...state,
        items: state.items.filter((el) => el._id !== action.id_todo),
      };
    default:
      return { ...state };
  }
};

export default TodoAppReducer;
